import Card, { CardProps } from '@mui/material/Card';
import { PaletteRarity, useTheme } from '@mui/material/styles';
import { useRef, useState, useEffect } from 'react';
import { LootboxCardBackground } from './LootboxCardBackground';
import Box from '@mui/material/Box';

export type CardSlotProps = CardProps & {
  shape?: 'Pack' | 'Box' | 'Card' | 'LootBox';
  rarity?: keyof PaletteRarity;
  content?: 'item' | 'game' | 'profile' | 'recentGame';
  children?: JSX.Element | JSX.Element[];
};

// TODO: Lootbox shape implementation
export const CardSlot = (props: CardSlotProps) => {
  const {
    shape = 'Card',
    content = 'item',
    children,
    rarity,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const heightRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState(310);
  const theme = useTheme();
  useEffect(() => {
    if (heightRef && heightRef.current) {
      setHeight(heightRef.current.clientHeight);
    }
  }, [heightRef]);
  const width =
    content === 'item'
      ? '254px'
      : content === 'game'
      ? '538px'
      : content === 'recentGame'
      ? '252px'
      : content === 'profile'
      ? '384px'
      : '100%';
  const border = children ? undefined : '0px';
  return (
    <Box
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{ position: 'relative' }}
    >
      {shape === 'LootBox' && (
        <LootboxCardBackground rarity={rarity ? rarity : 'common'} />
      )}
      {shape === 'Pack' && (
        <Card
          {...props}
          sx={{
            border,
            transform: 'rotate(3deg)',
            height,
            width,
            position: 'absolute',
          }}
        />
      )}
      <Card
        ref={heightRef}
        {...props}
        variant={content}
        sx={{
          border,
          borderStyle: shape === 'LootBox' ? 'solid' : undefined,
          width: shape === 'LootBox' ? '254px' : width,
          borderColor:
            shape === 'LootBox' ? theme.palette.rarity[`${rarity}`] : undefined,
          height:
            shape === 'LootBox'
              ? 318
              : content === 'profile'
              ? '100%'
              : undefined,
          minHeight:
            content === 'item'
              ? 310
              : content === 'game'
              ? 358
              : content === 'recentGame'
              ? 110
              : 132,
          boxShadow: shape === 'LootBox' ? 'none' : undefined,
          '&:hover':
            shape === 'LootBox'
              ? {
                  boxShadow: 'none',
                }
              : undefined,
        }}
      >
        {children}
      </Card>
    </Box>
  );
};
